module.exports = __webpack_public_path__ + "img/sweden_en.4f4e5eb3.png";